import React from 'react'
import { Link } from "react-router-dom";
import SliderHomeBanner from '../../component/slidercomponent/SliderHomeBanner';


const HomeBanner = () => {
    return (
        <>

            <div className="hero dark-section">
                {/* Video Start */}
                <div className="hero-bg-video">
                    {/* Selfhosted Video Start */}
                    {/* <video autoplay muted playsinline loop id="herovideo"><source src="./assets/images/hero-bg-video.mp4" type="video/mp4"></video> */}
                    <video autoPlay muted playsInline loop id="myvideo"><source src="./assets/videos/Solar Westa.mp4" type="video/mp4" /></video>
                    {/* Selfhosted Video End */}
                    {/* Youtube Video Start */}
                    {/* <div id="herovideo" class="player" data-property="{videoURL:'OjTRVpgtcG4',containment:'.hero-video', showControls:false, autoPlay:true, loop:true, vol:0, mute:false, startAt:0,  stopAt:296, opacity:1, addRaster:true, quality:'large', optimizeDisplay:true}"></div> */}
                    {/* Youtube Video End */}
                </div>
                {/* Video End */}
                <div className="container">
                    <div className="row">
                        <div className="col-xl-7">
                            {/* Hero Content Start */}
                            <div className="hero-content">
                                {/* Section Title Start */}
                                <div className="section-title">
                                    <span className="section-sub-title wow fadeInUp" style={{ visibility: 'visible', animationName: 'fadeInUp' }}>Solar Energy for Tomorrow</span>
                                    <h1 className="text-anime-style-3" data-cursor="-opaque" aria-label="Power Your Future with Clean Solar Energy" style={{ perspective: 400 }}>
                                        <div className="split-line" aria-hidden="true" style={{ position: 'relative', display: 'block', textAlign: 'start' }}>
                                            <div aria-hidden="true" style={{ position: 'relative', display: 'inline-block', fontSize:"38px", lineHeight:"50px" }}>
                                              ☀️ Clean Energy | Smart Solutions
                                                {/* ☀️ Clean Energy | 💡 Smart Solutions | 🌱 Sustainable Future */}
                                            </div>
                                        </div>
                                    </h1>
                                    <p className="wow fadeInUp" data-wow-delay="0.2s" style={{ visibility: 'visible', animationDelay: '0.2s', animationName: 'fadeInUp',textAlign:"justify" }}>Residential Solar | Commercial Solar | Industrial Solar | Rooftop Solar | Solar EPC | Solar Water Pumps | Solar Street Lights | Solar </p>
                                </div>
                                {/* Section Title End */}
                                {/* Hero Content Body Start */}
                                <div className="hero-content-body wow fadeInUp" data-wow-delay="0.4s" style={{ visibility: 'visible', animationDelay: '0.4s', animationName: 'fadeInUp' }}>
                                    {/* Hero Button Start */}
                                    <div className="hero-btn">
                                        <Link to="https://wa.me/919516839231" className="btn-default btn-highlighted">Order Book</Link>
                                    </div>
                                    {/* Hero Button End */}
                                    {/* Video Play Button Start */}
                                    <div className="video-play-button" data-cursor-text="Play">
                                        <a to="https://www.youtube.com/watch?v=Y-x0efG1seA" className="popup-video">
                                            <span><i className="fa-solid fa-play" /></span>
                                            <p>Watch Our Story</p>
                                        </a>
                                    </div>
                                    {/* Video Play Button End */}
                                </div>

                            </div>
                            {/* Hero Content End */}
                        </div>
                    </div>
                </div>
            </div>



        </>
    )
}

export default HomeBanner